var headerScrollHandler = () => {
	let header = document.querySelectorAll('div.header')
	const startedOffset = 10
	const pageOffset = window.pageYOffset

	if(header.length !== 1) {
		return
	} else {
		header = header[0]
	}

	// ak header dosiahol hranicu alebo je POD nou, zapni class
	if (pageOffset >= startedOffset) {
		if (false === window.hasClass(header, 'header-scrolling')) {
			window.addClass(header, 'header-scrolling')
		}
	}

	// ak je header NAD hranicou, vypni class
	if (pageOffset < startedOffset) {
		if (true === window.hasClass(header, 'header-scrolling')) {
			window.removeClass(header, 'header-scrolling')
		}
	}
}

window.documentReady(() => {
	headerScrollHandler()

	let selects = $('select')
	let datepickers = $('[data-toggle="datepicker"]')

	// Mobile navigation toggling
	const mobileNavToggle = document.querySelectorAll('.toggle-mobile-nav')
	if(mobileNavToggle.length === 1){
		mobileNavToggle[0].addEventListener('click', (e) => {
			e.preventDefault()
			const classOpened = 'mobile-nav-opened'
			const hasOpenedClass = window.hasClass(document.body, classOpened)

			if(hasOpenedClass) {
				window.removeClass(document.body, classOpened)
			} else {
				window.addClass(document.body, classOpened)
			}
		})
	}

	// Scroll links - scroll to anchor
	document.querySelectorAll('a[data-toggle="scroll"]').forEach((link) => {
		link.addEventListener('click', (e) => {
			e.preventDefault()
			let targetElement = document.getElementById(link.getAttribute('href').substr(1))
			window.scrollToElement(document.documentElement, targetElement.offsetTop);
		})
	})


	jQuery('.collapse').on('hide.bs.collapse', (e) => {
		jQuery(e.target).closest('.collapse-item').removeClass('active')
	}).on('show.bs.collapse', (e) => {
		jQuery(e.target).closest('.collapse-item').addClass('active')
	})


	if(selects.length > 0){
		selects.each((i,element) => {
			// eslint-disable-next-line
			new SlimSelect({
				select: element
			})
		})
	}

	if(datepickers.length > 0){
		datepickers.datepicker({
			format: 'dd.mm.yyyy',
			language: 'cs-CZ'
		})
	}

	$('a.program').on('click', (e) => {
		e.preventDefault()

		let $this = $(e.currentTarget)
		let relatedCollapse = $this.attr('href') === '#' ? null : $($this.attr('href'))

		$($this).toggleClass('active')
		if($($this).hasClass('active')){
			if(relatedCollapse !== null && relatedCollapse.length > 0){
				relatedCollapse.collapse('show')
			}

			let otherPrograms = $('a.program').not($this)

			otherPrograms.removeClass('active')
			otherPrograms.each((i, program) => {
				program = $(program).attr('href') === '#' ? null : $($(program).attr('href'))
				if(program !== null && program.length > 0){
					program.collapse('hide')
				}
			})
		} else {
			relatedCollapse.collapse('hide')
		}
	})


	$('.counter a.arrow').on('click', (e) => {
		e.preventDefault()

		let $this = $(e.currentTarget)
		let counter = $this.closest('.counter')
		let input = counter.find('input')


		if($this.hasClass('arrow-plus')) {
			input.val(parseInt(input.val(), 10) + 1)
		} else {
			let currentVal = parseInt(input.val(), 10)
			if(currentVal > 0){
				input.val(currentVal - 1)
			}
		}

	})

})




window.addEventListener('scroll', () => {
	headerScrollHandler()
})

